import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RailcarTerminalMultiSelect from './RailcarTerminalMultiSelect';
import WarningIcon from '@material-ui/icons/Warning';

import FormComponent from '../../components/FormComponent';
import { Accordion, AccordionDetails, AccordionSummary, Paper } from '@material-ui/core';
import FMPText from '../../components/pureForm/FMPText';
import { ingestedTerminalIds } from './constants';
import { RailcarUnion } from './RailcarUnion';
import FMPSelect from '../../components/pureForm/FMPSelect';

function filterBySearchString(railcarUnions, searchString) {
	const searchLower = searchString.toLowerCase();

	return railcarUnions.filter((railcarUnion) => {
		// Check each delivery leg in the allDeliveryLegs array
		for (let railcar of railcarUnion.railcars) {
			if (railcar.railcarNumber && railcar.railcarNumber.toLowerCase().includes(searchLower)) {
				return true;
			}

			if (railcar.railcarNumber && railcar.railcarId === parseInt(searchLower)) {
				return true;
			}
		}

		// Check each delivery leg in the allDeliveryLegs array
		for (let leg of railcarUnion.allDeliveryLegs) {
			// Check the 'bol' field for a match
			if (leg.bol && leg.bol.toLowerCase().includes(searchLower)) {
				return true;
			}
			// Check the 'stationDeliveryId' field for a match
			if (leg.stationDeliveryId && leg.stationDeliveryId.toString().includes(searchLower)) {
				return true;
			}
		}

		// If no fields match, filter out this item
		return false;
	});
}

export function filterByTerminal(data, terminalIds, quickFilterPoMonth) {
	return data.filter((item) => {
		if (_.includes(terminalIds, item.terminalId)) {
			if (quickFilterPoMonth) {
				if (item.requestedMonth === quickFilterPoMonth) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		} else {
			return false;
		}
	});
}

const SETTINGS_KEY = 'railcarMasterSheetSaveSettings';
export default class RailcarListing extends FormComponent {
	constructor(props) {
		super(props);
		console.log('my props', this.props);

		let terminalIds = ingestedTerminalIds;
		if (localStorage.getItem(SETTINGS_KEY)) {
			try {
				const savedSettings = JSON.parse(localStorage.getItem(SETTINGS_KEY));
				if (savedSettings && savedSettings.terminalIds) {
					terminalIds = savedSettings.terminalIds;
				}
			} catch (e) {
				console.error('problems fetching settings from local storage', e);
			}
		}

		if (this.props.filterByTerminalId) {
			terminalIds = [parseInt(this.props.filterByTerminalId, 10)];
		}

		this.state = {
			quickFilterRailcar: this.props.filterByRailcarNumber,
			isPastExpanded: false,
			terminalIds,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.terminalIds !== this.state.terminalIds) {
			localStorage.setItem(SETTINGS_KEY, JSON.stringify({ terminalIds: this.state.terminalIds }));
		}
	}

	togglePastAccordion = () => {
		this.setState((prevState) => ({
			isPastExpanded: !prevState.isPastExpanded,
		}));
	};

	render() {
		const {
			classes,
			railcarUnionsWithDeliveriesFormatted,
			monthOptions,
			copyToClipboard,
			pastRailcarErrors,
			recentRailcarErrors,
			apiErrors,
		} = this.props;
		const { quickFilterRailcar, terminalIds, quickFilterPoMonth } = this.state;

		if (!railcarUnionsWithDeliveriesFormatted) {
			return (
				<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
					<Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
						Loading...
					</Grid>
				</Grid>
			);
		}

		let { past, current, inbound, future } = railcarUnionsWithDeliveriesFormatted;
		let expandPast = false;
		let expandFuture = false;
		let expandInbound = true;

		past = filterByTerminal(past, terminalIds, quickFilterPoMonth);
		current = filterByTerminal(current, terminalIds, quickFilterPoMonth);
		inbound = filterByTerminal(inbound, terminalIds, quickFilterPoMonth);
		future = filterByTerminal(future, terminalIds, quickFilterPoMonth);
		const railcarErrors = filterByTerminal(pastRailcarErrors, terminalIds, quickFilterPoMonth);
		const currentErrors = filterByTerminal(recentRailcarErrors, terminalIds, quickFilterPoMonth);

		if (quickFilterRailcar && quickFilterRailcar.length >= 3) {
			current = filterBySearchString(current, quickFilterRailcar);
			past = filterBySearchString(past, quickFilterRailcar);
			if (!_.isEmpty(past)) {
				expandPast = true;
			}

			future = filterBySearchString(future, quickFilterRailcar);
			if (!_.isEmpty(future)) {
				expandFuture = true;
			}

			inbound = filterBySearchString(inbound, quickFilterRailcar);
			if (!_.isEmpty(inbound)) {
				expandInbound = true;
			}
		}

		// I want to chunk the past ones by month
		const railcarUnionsByMonth = _.groupBy(
			past,
			(item) => item.requestedMonth
		);

		return (
			<>
				<Paper className={classes.paper} style={{ marginBottom: 10 }}>
					<div style={{ display: 'flex' }}>Quick Filter</div>

					<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
						<Grid item xs={4} style={{ textAlign: 'left' }}>
							<Grid spacing={2} container style={{ alignItems: 'flex-start', paddingTop: '7px' }}>
								<FMPText {...this.setForm(`quickFilterRailcar`, 'Railcar # or BOL')} />
							</Grid>
						</Grid>
						<Grid item xs={5} style={{ textAlign: 'left' }}>
							<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
								<RailcarTerminalMultiSelect
									{...this.setForm(`terminalIds`, 'Terminal Select', false, ingestedTerminalIds)}
								/>
								<div style={{ fontSize: '70%', color: '#888', marginLeft: '10px' }}>
									Will remember across refreshes
								</div>
							</Grid>
						</Grid>
						<Grid item xs={3} style={{ textAlign: 'left' }}>
							<FMPSelect
								{...this.setForm('quickFilterPoMonth', 'Month PO #', true)}
								options={monthOptions || []}
							/>
						</Grid>
					</Grid>
				</Paper>
				{!_.isEmpty(apiErrors) && (
					<Paper className={classes.paper} style={{ marginBottom: 10, background: '#ffd280' }}>
						<div
							style={{
								textTransform: 'uppercase',
								letterSpacing: '.5px',
							}}
						>
							Railcar Errors
						</div>
						{apiErrors.map((apiError) => {
							return <div key="apiError">{apiError}</div>;
						})}
					</Paper>
				)}
				<div>
					<Accordion
						width="100%"
						style={{ background: '#edfbe8', paddingX: '5px' }}
						expanded={this.state.isPastExpanded || expandPast}
						onChange={this.togglePastAccordion}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
							style={{
								fontSize: '90%',
							}}
						>
							<div>
								<div
									style={{
										textTransform: 'uppercase',
										letterSpacing: '.5px',
									}}
								>
									Relinquished Railcars ({past.length})
								</div>

								<RailcarErrors
									errors={currentErrors}
									title="Recent Issues (past week)"
									classes={classes}
								/>
							</div>
						</AccordionSummary>
						<AccordionDetails>
							<div style={{ width: '100%' }}>
								<RailcarErrors errors={railcarErrors} title="Past Issues" classes={classes} />
								{_.keys(railcarUnionsByMonth).map((month) => {
									const pastRailcarUnions = _.sortBy(
										railcarUnionsByMonth[month],
										(union) => _.first(union.railcars).apDate || 'zzzz'
									);
									return (
										<div key={month}>
											<div
												style={{
													paddingTop: 10,
													fontWeight: 'bold',
													fontSize: '110%',
													color: '#666',
													paddingBottom: '3px',
												}}
											>
												Month: {moment(month).format('MMMM')}
											</div>
											<div style={{ width: '100%' }}>
												{pastRailcarUnions.map((pastRailcarUnion, i) => {
													return (
														<RailcarUnion
															key={`${month}_past_${i}`}
															railcarUnion={pastRailcarUnion}
															classes={classes}
															quickFilterPoMonth={quickFilterPoMonth}
															copyToClipboard={copyToClipboard}
															handleOpenUnlinkDialog={this.props.handleOpenUnlinkDialog}
														/>
													);
												})}
											</div>
										</div>
									);
								})}
							</div>
						</AccordionDetails>
					</Accordion>
				</div>

				{_.isEmpty(current) && (
					<div style={{ margin: 10, fontStyle: 'italic' }}>No railcars currently actualized.</div>
				)}
				{current.map((railcarUnion, i) => {
					return (
						<RailcarUnion
							key={`current${i}`}
							showRemaining={railcarUnion.emptyDate ? false : true}
							highlightEmpty={true}
							quickFilterPoMonth={quickFilterPoMonth}
							railcarUnion={railcarUnion}
							classes={classes}
							copyToClipboard={copyToClipboard}
							handleOpenUnlinkDialog={this.props.handleOpenUnlinkDialog}
						/>
					);
				})}

				<div style={{ marginBottom: 10 }}>
					<Accordion
						width="100%"
						style={{ background: '#fbf8e8', paddingX: '5px' }}
						defaultExpanded={expandInbound}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
							style={{ textTransform: 'uppercase', letterSpacing: '.5px', fontSize: '90%' }}
						>
							Inbound Railcars ({inbound.length})
						</AccordionSummary>
						<AccordionDetails>
							<div style={{ width: '100%' }}>
								{inbound.map((railcarUnion, i) => {
									return (
										<RailcarUnion
											key={`inbound_${i}`}
											railcarUnion={railcarUnion}
											showRemaining={true}
											classes={classes}
											quickFilterPoMonth={quickFilterPoMonth}
											copyToClipboard={copyToClipboard}
											handleOpenUnlinkDialog={this.props.handleOpenUnlinkDialog}
										/>
									);
								})}
							</div>
						</AccordionDetails>
					</Accordion>
				</div>

				<div>
					<Accordion
						width="100%"
						style={{ background: '#e8f5fb', paddingX: '5px' }}
						defaultExpanded={expandFuture}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
							style={{ textTransform: 'uppercase', letterSpacing: '.5px', fontSize: '90%' }}
						>
							Future Railcars ({future.length})
						</AccordionSummary>
						<AccordionDetails>
							<div style={{ width: '100%' }}>
								{future.map((railcarUnion, i) => {
									return (
										<RailcarUnion
											key={`future_${i}`}
											railcarUnion={railcarUnion}
											showRemaining={true}
											classes={classes}
											quickFilterPoMonth={quickFilterPoMonth}
											copyToClipboard={copyToClipboard}
											handleOpenUnlinkDialog={this.props.handleOpenUnlinkDialog}
										/>
									);
								})}
							</div>
						</AccordionDetails>
					</Accordion>
				</div>
			</>
		);
	}
}

RailcarListing.propTypes = {
	classes: PropTypes.object.isRequired,
	railcarUnionsWithDeliveriesFormatted: PropTypes.object,
	pastRailcarErrors: PropTypes.array,
	copyToClipboard: PropTypes.func.isRequired,
	terminalIds: PropTypes.array,
	handleOpenUnlinkDialog: PropTypes.func.isRequired,
};

class RailcarErrors extends Component {
	render() {
		const { errors, title, classes } = this.props;
		if (_.isEmpty(errors)) {
			return null;
		}

		return (
			<div>
				<div
					style={{
						paddingTop: '7px',
						textTransform: 'uppercase',
						letterSpacing: '.5px',
						fontSize: '90%',
					}}
				>
					{title}
				</div>

				{errors.map((error) => {
					return (
						<div key={error.message}>
							<WarningIcon className={classes.warningIcon} />
							{error.message}
						</div>
					);
				})}
			</div>
		);
	}
}

RailcarErrors.propTypes = {
	errors: PropTypes.array,
	title: PropTypes.string,
	classes: PropTypes.object,
	filterByRailcarNumber: PropTypes.string,
};
